import React, { useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import { Receipt, ChevronUp, ChevronDown, Zap, Building } from "lucide-react";
import { useDossier } from "@app/contexts/DossierContext";
import moment from "moment/moment";
import Tabs from "@app/components/2_widgets/Tabs";
import CspeDetails from "@app/components/2_widgets/cspe/CspeDetails";

export default function SectionCspe() {
    const [displaying, setDisplaying] = useState(false);

    const dossier = useDossier();
    const [activeTab, setActiveTab] = useState(dossier.structure_datas?.length > 0 ? dossier.structure_datas[0].id : null);

    const tabs = dossier.structure_datas?.map((st_data) => ({eventKey: st_data.id, tabTitle: st_data.structure?.trade_name, icon: <Building />}));
    
    const end_at = moment(dossier.tax_return?.fiscal_closing_date).format("DD-MM-YYYY");
    const start_at = moment(dossier.tax_return?.fiscal_starting_date).format("DD-MM-YYYY");

    function displayContent() {
        if (!displaying)
            return;
    
        return (
            <div>
                <p className="custom-row"><b>Période fiscale</b> : {start_at} au {end_at}</p>                
                <Tabs
                    tabs={tabs}
                    onTabChange={setActiveTab}
                    activeTab={activeTab}
                />
                <CspeDetails 
                    structureDataId={activeTab}                      
                />
            </div>
        ) 
    }

    return (
        <div className="page-section">
            <SectionTitle
                icon={<Receipt />}
                title="Récapitulatif des consommations"
                onClick={() => setDisplaying(!displaying)}
                rightIcon={displaying ? <ChevronUp /> : <ChevronDown />}
                // badge={<Badge label={badgeLabel} classProp={`badge-${badgeStatus}`} />}
            />
            {displayContent()}            
        </div>
    )
}